import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ContentChildren, forwardRef, Input, QueryList } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { RadioButtonLayoutOptionDirective } from './radio-button-layout.directive';

@Component({
  selector: 'app-radio-button-layout',
  templateUrl: './radio-button-layout.component.html',
  styleUrl: './radio-button-layout.component.scss',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonLayoutComponent),
      multi: true,
    },
  ],
  imports: [NgTemplateOutlet, NgClass],
})
export class RadioButtonLayoutComponent implements ControlValueAccessor {
  @Input() direction: 'horizontal' | 'vertical' = 'vertical';

  // Query all projected options
  @ContentChildren(RadioButtonLayoutOptionDirective) optionList: QueryList<RadioButtonLayoutOptionDirective>;

  // Internal state
  selectedValue: any = null;
  disabled = false;

  // Callbacks required by ControlValueAccessor
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  // ─────────────────────────────────────────────────────────────
  // ControlValueAccessor implementation
  // ─────────────────────────────────────────────────────────────
  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Called when user clicks a radio button
  onRadioSelected(value: any): void {
    if (this.disabled) return;

    this.selectedValue = value;
    this.onChange(value); // Notify Angular forms
    this.onTouched(); // Mark as touched
  }
}
